export default "__VITE_ASSET__DQ3A7e_l__"